import React, { useEffect, useState } from "react";
import Axios from 'axios';
import '../../App.css';
import DynamicSelect from "./DynamicSelect";
import { Copy, Save, Check, Sparkles } from "lucide-react";
import { pickLookalike } from "./lookalikes";
import { useParams } from "react-router-dom";

export default function Edit(props) {

const { id } = useParams();
const [search, setSearch] = useState("");
const [originalSearch, setOriginalSearch] = useState("");
const [output, setOutput] = useState('');
const [type, setType] = useState("");
const [isHidden, setIsHidden] = useState(false);
const [copyState, setCopyState] = useState('idle');

Axios.defaults.withCredentials = true;

const handleClick = () => {
  if (copyState !== 'idle') return;
  navigator.clipboard.writeText(output);
  setCopyState('scanning');
  setTimeout(() => setCopyState('copied'), 280);
  setTimeout(() => setCopyState('idle'), 2300);
};

const saveClick = () => {
  if (output.length > 3) {
    Axios.post("https://mygamename.com/php/save.php", {
      email: props.uEmail,
      name: output,
    }).then((response) => {
      setType('saved');
      setIsHidden(true);
    });
  }
};

useEffect(() => {
  const fetchProtected = async () => {
    try {
      const response = await Axios.get('https://mygamename.com/php/protected.php', { withCredentials: true });
      if (response.data.status === 'success') {
        props.setUEmail(response.data.email);
        Axios.post("https://mygamename.com/php/edit.php", { id }).then((response) => {
          const name = response.data[0].name;
          setSearch(name);
          setOriginalSearch(name);
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  fetchProtected();
}, []);

return (
  <div className="mx-auto max-w-2xl py-12 px-4 flex flex-col gap-6">

    <h1 className="text-4xl text-center font-extrabold tracking-tight text-[#F5F5F5] md:text-5xl">Edit Name</h1>

    {/* Section 1 — Input */}
    <div className="bg-[#1a1a1a] border border-[#222222] rounded-xl p-5">
      <p className="text-[#8B5CF6] text-xs uppercase tracking-widest font-semibold mb-3">Input</p>
      <input
        className="bg-[#111111] border border-[#333333] text-[#F5F5F5] text-sm rounded-lg focus:ring-[#8B5CF6] focus:border-[#8B5CF6] block w-full p-3 placeholder-[#F5F5F5]/30 outline-none transition-colors"
        type="text"
        placeholder="Type your game name…"
        value={search}
        onChange={(e) => { setSearch(e.target.value); setOriginalSearch(e.target.value); }}
      />
    </div>

    {/* Section 2 — Modifications */}
    <div className="bg-[#1a1a1a] border border-[#222222] rounded-xl p-5 min-h-[100px]">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[#8B5CF6] text-xs uppercase tracking-widest font-semibold">Modifications</p>
        {search && (
          <button
            onClick={() => setSearch((originalSearch || search).split('').map(pickLookalike).join(''))}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-[#8B5CF6]/40 bg-[#8B5CF6]/10 text-[#8B5CF6] text-xs font-semibold hover:bg-[#8B5CF6]/20 hover:border-[#8B5CF6] transition-colors"
          >
            <Sparkles size={13} />
            Auto
          </button>
        )}
      </div>
      {search ? (
        <DynamicSelect search={search} setSearch={setSearch} output={output} setOutput={setOutput} originalSearch={originalSearch}/>
      ) : (
        <p className="text-[#F5F5F5]/30 text-sm">Enter a name above to start modifying characters.</p>
      )}
    </div>

    {/* Section 3 — Output */}
    <div className="bg-[#1a1a1a] border border-[#222222] rounded-xl p-5">
      <p className="text-[#8B5CF6] text-xs uppercase tracking-widest font-semibold mb-3">Output</p>
      <div className="min-h-[48px] mb-4">
        {output ? (
          <p className="text-[#F5F5F5] text-2xl font-bold break-all">{output}</p>
        ) : (
          <p className="text-[#F5F5F5]/30 text-sm">Your modified name will appear here.</p>
        )}
      </div>
      <div className="flex gap-3">
        {props.loginStatus && (
          <button
            onClick={saveClick}
            className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-[#333333] bg-[#111111] text-[#F5F5F5] text-sm font-semibold hover:border-[#8B5CF6] hover:bg-[#8B5CF6]/10 transition-colors"
          >
            <Save size={16} />
            Save
          </button>
        )}
        <button
          onClick={handleClick}
          className={`relative overflow-hidden w-full py-3 rounded-lg text-sm font-semibold border border-[#8B5CF6] text-[#F5F5F5] bg-[#8B5CF6] transition-colors ${
            copyState === 'idle'   ? 'copy-btn-idle cursor-pointer' :
            copyState === 'copied' ? 'copy-btn-copied cursor-default' :
            'cursor-default'
          }`}
        >
          {copyState === 'idle'     && <span className="copy-shimmer" />}
          {copyState === 'scanning' && <span className="copy-scan" />}
          <span className={`flex items-center justify-center gap-2 transition-all duration-200 ${
            copyState === 'scanning' ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
          }`}>
            {copyState === 'copied' ? <Check size={15} strokeWidth={3} /> : <Copy size={15} />}
            {copyState === 'copied' ? 'Locked in' : 'Copy Name'}
          </span>
        </button>
      </div>
      <div className={isHidden ? 'mt-3' : 'hidden'}>
        <p className="text-sm text-[#F5F5F5] rounded-lg bg-[#111111] border border-[#8B5CF6]/40 p-3">
          <span className="font-medium text-[#8B5CF6]">Done!</span> The name has been {type}.
        </p>
      </div>
    </div>

  </div>
);
}
